import { createContext } from 'react';

// eslint-disable-next-line no-unused-vars
const AuthStateContext = createContext();
// eslint-disable-next-line no-unused-vars
const AuthDispatchContext = createContext();

export const ApWoContext = createContext();
